import { Capacitor } from '@capacitor/core'
import type { ButtonProps } from '../Button'
import { Bare } from '../_variants/Bare/Bare'
import { Link } from '../_variants/Link/Link'
import { LinkNegative } from '../_variants/LinkNegative/LinkNegative'
import { List } from '../_variants/List/List'
import { Negative } from '../_variants/Negative/Negative'
import { Positive } from '../_variants/Positive/Positive'
import { Primary } from '../_variants/Primary/Primary'
import { Secondary } from '../_variants/Secondary/Secondary'
import { Tertiary } from '../_variants/Tertiary/Tertiary'

export const getButtonComponent = (variant: ButtonProps['variant']) => {
  switch (variant) {
    case 'primary':
      return Primary

    case 'secondary':
      return Secondary

    case 'tertiary':
      return Tertiary

    case 'positive':
      return Positive

    case 'negative':
      return Negative

    case 'link':
      return Link

    case 'link-negative':
      return LinkNegative

    case 'list':
      return List

    case 'bare':
      return Bare

    default:
      return Primary
  }
}

export const hoverCssKey = Capacitor.isNativePlatform() ? 'active' : 'hover' //The hover state isn't doing well on native platforms, so we're using the active state instead
